import React from 'react'
import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@mui/material'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import SPAContainer from './components/SPAContainer/SPAContainer'
import Login from './pages/Login'
import VerifyEmail from './pages/VerifyEmail'
import { AuthProvider } from './context/AuthContext'
import { ProfileProvider } from './context/ProfileContext'
import { ThemeProvider, useTheme } from './context/ThemeContext'
import ProtectedRoute from './components/Auth/ProtectedRoute'
import { getTheme } from './theme/theme'

function AppContent() {
  const { isDarkMode } = useTheme()
  const theme = getTheme(isDarkMode ? 'dark' : 'light')

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <ProfileProvider>
          <Router>
            <Routes>
              <Route path='/login' element={<Login />} />
              <Route
                path='/verify-email'
                element={
                  <ProtectedRoute requireVerification={false}>
                    <VerifyEmail />
                  </ProtectedRoute>
                }
              />
              <Route
                path='/'
                element={
                  <ProtectedRoute>
                    <SPAContainer />
                  </ProtectedRoute>
                }
              />
              <Route path='*' element={<Navigate to='/' />} />
            </Routes>
          </Router>
        </ProfileProvider>
      </AuthProvider>
    </MuiThemeProvider>
  )
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  )
}

export default App
